function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'jungle': 'rgb(177, 179, 116)','charcoal': 'rgb(142, 140, 140)','burgundy': 'rgb(185, 74, 68)','oyster': 'rgb(234, 216, 171)','pacific': 'rgb(42, 83, 131)','navy-blazer': 'rgb(23, 31, 44)','maroon': 'rgb(125, 38, 58)','charcoal-heather': 'rgb(70, 62, 61)','vintage-black': 'rgb(67, 65, 61)','sky-blue': 'rgb(214, 237, 247)','bone': 'rgb(245, 232, 206)','french-navy': 'rgb(7, 20, 41)','black': 'rgb(11, 11, 11)','mint': 'rgb(152, 255, 152)','custard': 'rgb(255, 253, 120)','sage': 'rgb(183, 184, 167)','dusty-pink': 'rgb(226, 212, 200)','purple': 'rgb(192, 172, 212)','light-blue': 'rgb(124, 206, 227)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','background color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
